import React, { useContext, useEffect, useState } from "react";
import {
  Tooltip,
  Paper,
  Container,
  Typography,
  Button,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TablePagination,
  TableRow,
  TableCell,
  CircularProgress,
  IconButton,
  Popover,
  TextField,
  InputAdornment,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Lottie from "react-lottie-player";
import ChatLottie from "../../../img/ChatBotLottie.json";
import { AntTabs, AntTab } from "../../Separaciones/tabs_style";
import { useMediaQuery } from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { ContextSession } from "../../../services/ContextSession";
import { Link } from "react-router-dom";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import SearchIcon from "@mui/icons-material/Search";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#19438C",
    color: "white",
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderRight: "none",
    borderLeft: "none",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: "#C1C1C1",
  },
}));

const ConsultasChatBot = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [tabIndex, setTabIndex] = React.useState(0);
  const navigate = useNavigate();
  let sessi = useContext(ContextSession);
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterType, setFilterType] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [searchID, setSearchID] = useState("");
  const [searchName, setSearchName] = useState("");
  const [searchDNI, setSearchDNI] = useState("");

  const [filas, setFilas] = useState([]); // Estado para guardar todos los datos
  const [filteredRows, setFilteredRows] = useState([]); // Estado para guardar los datos filtrados
  const [loading, setLoading] = useState(true);

  /*useEffect(() => {
        const fetchTickets = async () => {
            try {
                const response = await fetch('https://chatbot.injupemp.gob.hn/obtener_tickets/');
                const data = await response.json();
                setFilas(data.tickets || []); // Guardar todos los tickets en el estado
            } catch (error) {
                console.error('Error al cargar los tickets:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchTickets();
    }, []);*/

  useEffect(() => {
    const fetchTickets = async () => {
      setLoading(true);
      try {
        let url = "";
        if (tabIndex === 0) {
          url = "https://chatbot.injupemp.gob.hn/obtener_tickets_activos/";
        } else {
          url = "https://chatbot.injupemp.gob.hn/obtener_tickets/";
        }

        const response = await fetch(url);
        const data = await response.json();
        setFilas(data.tickets || []);
      } catch (error) {
        console.error("Error al cargar los tickets:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTickets();

    let interval = null;

    if (tabIndex === 0) {
      interval = setInterval(fetchTickets, 30000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [tabIndex]);

  useEffect(() => {
    const filtered = filas.filter((row) => {
      if (row.agente_asignado !== sessi.sessionData.id) {
        return false; // Excluir si el agente no coincide
      }
      const estadoFiltro =
        tabIndex === 0
          ? row.estado.toLowerCase() === "en proceso" ||
            row.estado.toLowerCase() === "pendiente"
          : row.estado.toLowerCase() !== "en proceso" &&
            row.estado.toLowerCase() !== "pendiente";

      const idMatch = searchID
        ? row.id
          ? row.id.toString().includes(searchID)
          : false
        : true;
      const nameMatch = searchName
        ? row.nombre.toLowerCase().includes(searchName.toLowerCase())
        : true;
      const dniMatch = searchDNI
        ? row.dni
          ? row.dni.toString().includes(searchDNI)
          : false
        : true;

      return estadoFiltro && idMatch && nameMatch && dniMatch;
    });
    setFilteredRows(filtered);
  }, [filas, tabIndex, sessi.sessionData.id, searchID, searchName, searchDNI]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleTabChange = (event, newValue) => setTabIndex(newValue);

  const handleClick = (id) => {
    sessi.setVariable("SolicitudChatbot", id);
    navigate("/PortalDelParticipante/VerConsultaChatBot");
  };

  const handleSearchIDChange = (event) => setSearchID(event.target.value);
  const handleSearchNameChange = (event) => setSearchName(event.target.value);
  const handleSearchDNIChange = (event) => setSearchDNI(event.target.value);

  const handleFilterClick = (event, type) => {
    setAnchorEl(event.currentTarget);
    setFilterType(type);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
    setFilterType("");
  };

  return (
    <>
      <Container style={{ marginTop: 15 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h4" fontWeight="bold">
            Lista Consultas Recibidas ChatBot INJUPEMP VIRTUAL
          </Typography>
        </div>

        <Box display="flex" justifyContent="center" alignItems="center">
          <Lottie
            loop
            animationData={ChatLottie}
            play
            style={{ width: "10%", height: "auto" }}
          />
        </Box>

        <Container>
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 5,
            }}
          >
            <Paper square>
              <AntTabs
                value={tabIndex}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{ style: { display: "none" } }}
              >
                <AntTab
                  label="Consultas Activas"
                  sx={{ textDecoration: tabIndex === 0 ? "underline" : "none" }}
                />
                <AntTab
                  label="Consultas Cerradas"
                  sx={{ textDecoration: tabIndex === 1 ? "underline" : "none" }}
                />
              </AntTabs>
            </Paper>
          </Box>
        </Container>
      </Container>

      <div className="row" style={{ marginTop: "20px" }}>
        {loading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="300px"
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <TableContainer component={Paper}>
              <Table style={{ fontSize: isMobile ? "7px" : "14px" }}>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <div>
                        <strong>ID Solicitud</strong>
                        <Tooltip title="Buscar por ID Solicitud" arrow>
                          <IconButton
                            onClick={(event) =>
                              handleFilterClick(event, "searchID")
                            }
                          >
                            <ManageSearchIcon style={{ color: "white" }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <div>
                        <strong>Nombre</strong>
                        <Tooltip title="Buscar por Nombre" arrow>
                          <IconButton
                            onClick={(event) =>
                              handleFilterClick(event, "search")
                            }
                          >
                            <ManageSearchIcon style={{ color: "white" }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <div>
                        <strong>Número de Identidad</strong>
                        <Tooltip title="Buscar por DNI" arrow>
                          <IconButton
                            onClick={(event) =>
                              handleFilterClick(event, "searchDNI")
                            }
                          >
                            <ManageSearchIcon style={{ color: "white" }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </StyledTableCell>{" "}
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <strong>Teléfono</strong>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <strong>Teléfono Alterno</strong>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <strong>Fecha Solicitud</strong>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <strong>Estado</strong>
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      <strong>Acciones</strong>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>

                <TableBody>
                  {filteredRows.length === 0 ? (
                    <StyledTableRow>
                      <StyledTableCell
                        colSpan={8}
                        style={{ textAlign: "center", fontSize: 17 }}
                      >
                        {tabIndex === 0
                          ? "No hay solicitudes activas"
                          : "No hay solicitudes cerradas"}
                      </StyledTableCell>
                    </StyledTableRow>
                  ) : (
                    filteredRows
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => (
                        <StyledTableRow key={row.id}>
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {row.id}
                          </StyledTableCell>
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {row.nombre.toUpperCase()}
                          </StyledTableCell>
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {row.dni}
                          </StyledTableCell>
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {row.telefono}
                          </StyledTableCell>
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {row.telefono_alterno ?? "NA"}
                          </StyledTableCell>
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {new Date(row.fecha_inicio).toLocaleString()}
                          </StyledTableCell>
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {row.estado.toUpperCase()}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            <div
                              className="action-buttons"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Link
                                onClick={() => handleClick(row.id)}
                                title="Ir Al Chat"
                                style={{ color: "#10ab80", margin: "0 1px" }}
                              >
                                <i className="material-icons">&#xE417;</i>
                              </Link>
                            </div>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleFilterClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              {filterType === "search" && (
                <TextField
                  placeholder="Buscar por Nombre"
                  variant="outlined"
                  value={searchName}
                  onChange={handleSearchNameChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
              {filterType === "searchID" && (
                <TextField
                  placeholder="Buscar por ID"
                  variant="outlined"
                  value={searchID}
                  onChange={handleSearchIDChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
              {filterType === "searchDNI" && (
                <TextField
                  placeholder="Buscar por DNI"
                  variant="outlined"
                  value={searchDNI}
                  onChange={handleSearchDNIChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            </Popover>
          </>
        )}

        {!loading && filteredRows.length > 0 && (
          <TablePagination
            rowsPerPageOptions={isMobile ? [3, 5, 10] : [5, 10, 20]}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={isMobile ? "Filas:" : "Filas por página"}
            labelDisplayedRows={({ from, to, count }) =>
              `${from} - ${to} de ${count}`
            }
          />
        )}
      </div>
    </>
  );
};

export default ConsultasChatBot;
